'use client';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Quanto custa criar uma holding patrimonial?",
    answer: "O investimento varia de acordo com a complexidade do patrimônio e quantidade de imóveis. Oferecemos uma consultoria inicial gratuita para avaliar seu caso e apresentar um orçamento personalizado. Geralmente, o custo inicial é recuperado em um ou dois anos através da economia tributária.",
  },
  {
    question: "Quanto tempo leva o processo completo?",
    answer: "O processo completo leva em média de 30 a 60 dias, dependendo da quantidade de imóveis e da agilidade nos trâmites cartorários. Isso inclui a constituição da holding, transferência dos bens e regularização contábil.",
  },
  {
    question: "Preciso contratar um advogado separadamente?",
    answer: "Não necessariamente. A Patriar trabalha com uma rede de advogados parceiros especializados em direito societário e imobiliário. Todo o processo é coordenado por nossa equipe, oferecendo uma solução completa.",
  },
  {
    question: "Qual o custo mensal de manutenção da holding?",
    answer: "O custo mensal inclui a contabilidade especializada, declarações fiscais e acompanhamento. Os valores variam conforme a complexidade da estrutura, mas geralmente são menores que os impostos economizados. Apresentamos todos os custos de forma transparente na consultoria.",
  },
  {
    question: "Minha holding pode ter outros bens além de imóveis?",
    answer: "Sim! Uma holding patrimonial pode administrar diversos tipos de bens como participações societárias, veículos, investimentos financeiros e outros ativos. Avaliamos a melhor estrutura para incluir todo seu patrimônio.",
  },
  {
    question: "A holding é indicada para qualquer patrimônio?",
    answer: "A holding é mais vantajosa para proprietários de imóveis que recebem mais de R$ 5.000 de aluguel mensal, mas cada caso é único. Na consultoria gratuita, analisamos se a estrutura faz sentido para sua situação específica e qual seria a economia real.",
  },
];

export default function FAQAccordion() {
  return (
    <Accordion type="single" collapsible className="w-full space-y-2">
      {faqs.map((faq, index) => (
        <AccordionItem
          key={index}
          value={`item-${index}`}
          className="border-b border-navy-100 last:border-b-0"
        >
          <AccordionTrigger className="text-left text-base sm:text-lg font-medium text-navy-900 hover:text-gold-500 py-5">
            {faq.question}
          </AccordionTrigger>
          <AccordionContent className="text-neutral-600 pb-5 leading-relaxed">
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
